import { fetchVaultConfig } from "../api/vault-config";
const getVaultByKey = async (vaultKey) => {
  const vaultConfig = await fetchVaultConfig(vaultKey);
  if (!vaultConfig) {
    throw new Error(`Vault key ${vaultKey} not found`);
  }
  return vaultConfig;
};
export {
  getVaultByKey
};
//# sourceMappingURL=index.mjs.map